import React, { Component } from 'react';
import logger from './../utils/logger.js';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    if (error && error.message && error.message.includes('ResizeObserver')) {
      // Suppress ResizeObserver errors from UI
      this.setState({ hasError: false, errorInfo: null });
      return;
    }
    
    this.setState({ errorInfo });
    logger.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.props.fallback) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 